import { render, staticRenderFns } from "./DoneStep.vue?vue&type=template&id=b23b00f2&scoped=true"
import script from "./DoneStep.vue?vue&type=script&lang=js"
export * from "./DoneStep.vue?vue&type=script&lang=js"
import style0 from "./DoneStep.vue?vue&type=style&index=0&id=b23b00f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23b00f2",
  null
  
)

export default component.exports